import ReactPiwik from "react-piwik";

export function initMatomo() {
  try {
    const piwik = new ReactPiwik({
      url: 'tracking.jde-mediabox.com',
      siteId: 1,
      trackErrors: false, // avoid console noise when tracking server is unreachable
      trackPageView: true,
      enableLinkTracking: true,
      jsFilename: 'matomo.js',
      phpFilename: 'matomo.php'
    });
    ReactPiwik.push(['addDownloadExtensions', "jpg|jpeg|eps|zip|png"]);
    return piwik;
  } catch (e) {
    // Tracking server unreachable — fail silently, never block the app
    return null;
  }
}
